import { nanoid } from 'nanoid';

export const createInitialFileData = (urls: string[] | null): string | undefined => {
  if (urls) {
    const fileData = urls.map((url) => ({
      url,
      id: nanoid(),
    }));

    return JSON.stringify(fileData);
  }

  return undefined;
};
